import { Component } from '@angular/core';


@Component({
  selector: 'app-allcategories',
  templateUrl: './allcategories.component.html',
  styleUrls: ['./allcategories.component.scss'] // ⬅️ صح
})
export class AllcategoriesComponent  {
 
  constructor(
  ) {


  }
  ngOnInit(): void {
   
  }
   
}
